/* eslint-disable camelcase */
import { Serializable } from '@core/models';

export class SectionChange extends Serializable {
  constructor(sectionGuid, confirmed, menuProductChanges) {
    super();
    this.sectionGuid = sectionGuid;
    this.confirmed = confirmed;
    this.menuProductChanges = menuProductChanges || [];
  }

  serialize() {
    const change_list = this.confirmed ? this.menuProductChanges.map((change) => change.serialize()) : [];
    return {
      section_guid: this.sectionGuid,
      confirmed: this.confirmed,
      change_list
    };
  }
}
